export var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["PERSONAL_INFO"] = "personal-info";
    OnboardingStep["COMPANY_INFO"] = "company-info";
    OnboardingStep["INVITE_TEAMMATES"] = "invite-teammates";
    OnboardingStep["SET_PASSWORD"] = "set-password";
})(OnboardingStep || (OnboardingStep = {}));
